import { withRouter } from 'react-router-dom';
import GoogleAnalytics from './GoogleAnalytics';

export default withRouter(GoogleAnalytics);
